// extracted by mini-css-extract-plugin
export default {"googleBtn":"register_googleBtn__wV2YU","formContainer":"register_formContainer__mRLVN"};